export default "__VITE_ASSET__e332431b__"